import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiEmployeeShort } from "@/types/employees/employee.types.ts";
import { ApiWorkflowShort } from "@/types/workflows/workflow.types.ts";
import { Stack, Text, Tooltip, TooltipContent, TooltipTrigger } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

type CreatedByWorkflowInlineProps = {
  workflow: ApiWorkflowShort;
  author?: ApiEmployeeShort;
};

export const CreatedByWorkflowInline = ({ workflow, author }: CreatedByWorkflowInlineProps) => {
  const { renderEmployeeName } = useFormatter();
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger>
        <Text className={"text-secondary"}>{t("common:workflow")}</Text>
      </TooltipTrigger>
      <TooltipContent>
        <Stack items={"center"} gap={"xs"}>
          <Text>{workflow.title}</Text>
          {author && (
            <Stack direction={"horizontal"} items={"center"} gap={"xs"}>
              <EmployeeAvatar size={"sm"} employee={author} />
              <Text className={"text-light"}>{renderEmployeeName(author)}</Text>
            </Stack>
          )}
        </Stack>
      </TooltipContent>
    </Tooltip>
  );
};
